import { IChat } from "../../../../interface/Chat";


export const removeConversation = (chats: IChat[], conversationId: string) =>
{
  return chats.filter(chat => chat._id !== conversationId)
}